const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

const request = async (path, init = {}) => {
  const response = await fetch(`${API_BASE}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init.headers || {}),
    },
  });

  if (!response.ok) {
    let detail = `HTTP ${response.status}`;
    try {
      const payload = await response.json();
      detail = payload?.detail || detail;
    } catch (_e) {
      // noop
    }
    throw new Error(detail);
  }

  return response.json();
};

export const fetchTenants = () => request('/api/tenant-admin/tenants');
export const fetchTenantDetail = (tenantId) => request(`/api/tenant-admin/tenants/${encodeURIComponent(tenantId)}`);
export const createTenant = (payload) => request('/api/tenant-admin/tenants', { method: 'POST', body: JSON.stringify(payload) });
export const updateTenant = (tenantId, payload) => request(`/api/tenant-admin/tenants/${encodeURIComponent(tenantId)}`, { method: 'PUT', body: JSON.stringify(payload) });
export const changeTenantPlan = (tenantId, plan) => request(`/api/tenant-admin/tenants/${encodeURIComponent(tenantId)}/change-plan`, { method: 'POST', body: JSON.stringify({ plan }) });
export const fetchTenantFeatures = (tenantId) => request(`/api/tenant-admin/tenants/${encodeURIComponent(tenantId)}/features`);
export const overrideTenantFeature = (tenantId, featureKey, enabled) => request(`/api/tenant-admin/tenants/${encodeURIComponent(tenantId)}/override-feature`, {
  method: 'POST',
  body: JSON.stringify({ featureKey, enabled }),
});
export const fetchTenantModules = (tenantId) => request(`/api/tenant-admin/tenants/${encodeURIComponent(tenantId)}/modules`);
export const fetchTenantUsage = (tenantId) => request(`/api/tenant-admin/tenants/${encodeURIComponent(tenantId)}/usage`);
